"use strict";
/* CONFIG PARALAX ILLUSTRATIONS*/

const prlx_pic_config = {
    x_deg: 6,     // Maksimalus posisukimas laipsniais X ašyje
    y_deg: 3,     // Maksimalus posisukimas laipsniais Y ašyje
    x_speed: 0.04,    // X ašies sukimosi greitis. Skaičiaus ribos 0 > x <= 1 (kuo mažesnis, tuo lėčiau juda)
    y_speed: 0.04,    // Y ašies sukimosi greitis. Skaičiaus ribos 0 > y <= 1 (kuo mažesnis, tuo lėčiau juda)

    mobile_breakpoint: 480    // Plotis, kuriame persijungiama į mobiliojo režimą (paveiksliukas nebereaguoja į pelę, tik į scroll'ą)
};

/* END CONFIG PARALAX ILLUSTRATIONS*/

$(function () {
    if ($('.c-3d-container').length == 0) return;

    const imglist = [];
    const mouse = {
        x: 0,
        y: 0,
        ox: 0,
        oy: 0,
        dx: 0,
        dy: 0,
        px: 0,
        py: 0
    }
    $('.c-3d-container').each(function (id, el) {
        imglist.push({element: $(el).find('.c-cursor-tracker'), wrapper: $(el)});
    });
    recalc();

    function recalc() {
        requestAnimationFrame(function (t) {
            var scrl = $(document).scrollTop();
            imglist.forEach(function (o, id) {
                //console.log(o.wrapper.offset(), o.wrapper.width(), o.wrapper.height());
                o.pos = o.wrapper.offset();
                //o.pos.left += Math.round(o.wrapper.width() * 0.5);
                o.pos.left = $(window).width() / 2;
                o.pos.top += Math.round(o.wrapper.height() * 0.5) - scrl;
                if (!o.rpos) o.rpos = {};
                o.rpos.left = o.pos.left / $(window).width();
                o.rpos.top = o.pos.top / $(window).height();
                o.visible = o.pos.top > -125 && o.pos.top < $(window).height() + 125;
                //console.log(o.visible , o.pos.top);
                if (!o.rotation) {
                    o.rotation = {};
                    o.rotation.x = 0;
                    o.rotation.y = 0;
                }
            });
        });

    }

    function mouseCalc(e) {
        mouse.ox = mouse.x;
        mouse.oy = mouse.y;
        mouse.x = e.clientX;
        mouse.y = e.clientY;
        mouse.dx = mouse.x - mouse.ox;
        mouse.dy = mouse.y - mouse.oy;
        mouse.px = mouse.x / $(window).width() * 2 - 1;
        mouse.py = mouse.y / $(window).height() * 2 - 1;
    }

    function anim() {
        requestAnimationFrame(anim);
        imglist.forEach(function (o, id) {
            if (o.visible) {
                var mx, my;
                if (window.innerWidth <= prlx_pic_config.mobile_breakpoint) {
                    mx = 0;
                    my = -(-(o.rpos.top * 2 - 1)) * prlx_pic_config.y_deg * 2;
                } else {
                    mx = -(-mouse.px + (o.rpos.left * 2 - 1)) * prlx_pic_config.x_deg;
                    my = -(mouse.py - (o.rpos.top * 2 - 1)) * prlx_pic_config.y_deg;
                }
                if (o.rotation.x != mx || o.rotation.y != my) {
                    if (Math.abs(mx - o.rotation.x) < 0.01) {
                        o.rotation.x = mx;
                    } else {
                        o.rotation.x += (mx - o.rotation.x) * prlx_pic_config.x_speed;
                    }
                    if (Math.abs(my - o.rotation.y) < 0.01) {
                        o.rotation.y = my;
                    } else {
                        o.rotation.y += (my - o.rotation.y) * prlx_pic_config.y_speed;
                    }
                    o.element.css("transform", "translateZ(0) rotateY(".concat(o.rotation.x.toFixed(3), "deg) rotateX(", o.rotation.y.toFixed(3), "deg)"));
                }
            }
        });
    }

    requestAnimationFrame(anim);

    window.addEventListener("scroll", recalc);
    window.addEventListener("resize", recalc);
    window.addEventListener("mousemove", mouseCalc);
});